export default "__VITE_ASSET__Bcg7DjzF__"